/* global StackDiscounts */
/* global eggoOrderLimit */

import {EggoCart} from "./eggo-cart";
import {
    EVENT_SHOW_MINI_CART,
    documentEventDispatcher,
    EVENT_HIDE_MINI_CART_LOADER,
    EVENT_ADD_TO_CART,
    EVENT_GENERATE_UPSELLS,
    EVENT_UPDATE_PRICES,
    EVENT_CALCULATE_SHIPPING,
    EVENT_REMOVE_GIFTS, EVENT_TOGGLE_CHECKOUT
} from "./eggo-cart-events";

let eggoCart = null;

const openMiniCartOnIcon = () => {
    const miniCartIcon = document.querySelector(".header__icon--cart");
    if (!miniCartIcon) return;
    miniCartIcon.addEventListener("click", (e) => {
        e.preventDefault();
        openCartProcedure();
    });
}

const openCartProcedure = () => {
    if (!eggoCart) {
        eggoCart = new EggoCart();
        eggoCart.getCart();
    } else {
        documentEventDispatcher(EVENT_SHOW_MINI_CART);
    }
}


export const addToCart = (addToCartData) => {
    const url = `${routes.cart_add_url}.js`;
    const body = {
        items: addToCartData,
    };
    if (!eggoCart) {
        eggoCart = new EggoCart();
        eggoCart.getCart(url, body);
    } else {
        documentEventDispatcher(EVENT_ADD_TO_CART, {
            url: url,
            data: body
        });
    }
}

export const removeItemCart = (productId) => {
    const url = `${routes.cart_change_url}.js`;
    const body = {
        id: productId,
        quantity: 0
    }

    if (!eggoCart) {
        eggoCart = new EggoCart();
        eggoCart.getCart(url, body);
    } else {
        documentEventDispatcher(EVENT_ADD_TO_CART, {
            url: url,
            data: body
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    openMiniCartOnIcon();
    registerToggleCheckout();
    (function () {
        let origOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function () {
            setTimeout(() => {
                if (this._url && this._url.includes("https://stack-discounts.merchantyard.com/api/shopify/coupons/validate")) {
                    this.addEventListener('load', (e) => {
                        documentEventDispatcher(EVENT_GENERATE_UPSELLS);
                        const response = JSON.parse(this.response);
                        if (response?.cart_items_breakdown) {
                            const breakdown = response.cart_items_breakdown;
                            const breakDownEntriesCount = Object.entries(breakdown).length;
                            if (breakDownEntriesCount) {
                                documentEventDispatcher(EVENT_UPDATE_PRICES, breakdown);
                            }
                        }
                        if (eggoOrderLimit && eggoOrderLimit?.enabled && eggoOrderLimit?.limit > 50) {
                            documentEventDispatcher(EVENT_TOGGLE_CHECKOUT, {
                                limit: eggoOrderLimit.limit,
                                total: response.total_value
                            });
                        }
                        documentEventDispatcher(EVENT_CALCULATE_SHIPPING, response.total_value);
                        documentEventDispatcher(EVENT_HIDE_MINI_CART_LOADER);
                    });
                }
            }, 0);

            origOpen.apply(this, arguments);
        };
    })();
});

function registerToggleCheckout() {
    document.addEventListener(EVENT_TOGGLE_CHECKOUT, function (event) {
        const isCartPage = document.getElementById("cart-page");
        let button = null;
        let message = null;

        if (isCartPage) {
            button = document.querySelector("#cart-page #checkout");
            message = document.querySelector("#cart-page #cart-notification-button-message");
        } else {
            button = document.querySelector(".cart-drawer__inner-real #cart-notification-button");
            message = document.querySelector(".cart-drawer__inner-real #cart-notification-button-message");
        }

        const {detail} = event;
        const {limit, total} = detail;
        if (!button) return;
        if (total > limit) {
            button.classList.add("hide");
            if (message) message.classList.add("show");
        } else {
            button.classList.remove("hide");
            if (message) message.classList.remove("show");
        }
    });
}
